<template>
  <b-form-select
    :value="currentBranch.id"
    @input="handleChange"
  >
    <template v-for="branch in branches">
      <b-form-select-option
        :key="branch.id"
        :value="branch.id"
      >
        {{ branch.name }}
      </b-form-select-option>
    </template>

    <b-form-select-option
      v-if="canManageBranches"
      :value="-1"
    >
      {{ $t('branch.add-new-branch') }}
    </b-form-select-option>
  </b-form-select>
</template>

<script>
import { BFormSelect, BFormSelectOption } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import PermissionMixin from '@/mixins/permission-mixin'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default {
  name: 'CurrentBranchSelect',
  components: {
    BFormSelect, BFormSelectOption,
  },
  mixins: [PermissionMixin],
  computed: {
    ...mapGetters({
      branches: 'branches/branches',
      currentBranch: 'branches/currentBranch',
    }),
    canManageBranches() {
      return this.hasSubuserPermission(SUBUSER_PERMISSION_SLUGS.BRANCHES_MANAGE)
    },
  },
  methods: {
    handleChange(branchId) {
      if (branchId === -1) {
        this.$store.dispatch('branches/REQUEST_ADD_BRANCH')
      } else {
        this.$store.dispatch('branches/SET_BRANCH', branchId)
      }
    },
  },
}
</script>
